import { Box, Stack, Typography } from '@mui/material';
import { ComponentType } from 'react';

export interface EmptyStateWithIllustrationProps {
  Illustration?: ComponentType<React.SVGProps<SVGSVGElement>>;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export function EmptyStateWithIllustration({
  Illustration,
  title,
  description,
  action,
}: EmptyStateWithIllustrationProps) {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      textAlign="center"
      maxWidth={400}
      margin="auto"
    >
      {Illustration && <Box>{<Illustration width={245} height={180} />}</Box>}
      <Stack spacing={1}>
        {title && (
          <Typography variant="title-s" component="h2">
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body-xs" component="p">
            {description}
          </Typography>
        )}
      </Stack>
      {action}
    </Stack>
  );
}
